import React from "react"
import { IObjectAudit } from "../../models"
import { grey700 } from "material-ui/styles/colors"
import moment from "moment"
interface IProps {
    label: string
    audit: IObjectAudit
}
const AuditShow: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ fontSize: 12, color: grey700, textAlign: "center" }}>
            <span style={{ marginRight: 8 }}>{props.label}:</span>
            <span>{moment(props.audit.LastModified).format("MM/DD/YYYY")}</span>
            <br />
            <span>{props.audit.LastModifiedByName}</span>
        </div>
    )
}

export default AuditShow